import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { COLOR, gradient, textGradient } from "../common/css/colors";
import { Button } from "../components";

import "../styles/home.css";

const Home = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                flex: 1,
                width: "100%",
            }}
        >
            <div
                style={{
                    maxWidth: "1080px",
                    borderStyle: "solid",
                    borderWidth: "0 1px",
                    borderColor: "rgba(255, 255, 255, 0.1)",
                    flex: 1,
                    width: "100%",
                }}
            >
                <Navbar />
                <Panel1 />
                <Panel2 />
            </div>
        </div>
    );
};

const Navbar = () => {
    const [, setLocation] = useLocation();

    return (
        <div
            className="nav-container"
            style={{
                paddingInline: "2em",
            }}
        >
            <a href="/" style={{ textDecoration: "none" }}>
                <h1
                    style={{
                        userSelect: "none",
                        ...textGradient(COLOR.teal3, COLOR.lime3, 45),
                    }}
                >
                    questie
                </h1>
            </a>

            <div>
                <Button
                    text="Log in"
                    style={{ marginRight: "1em" }}
                    variant="outline"
                    onClick={() => setLocation("/login")}
                />
                <Button
                    text="Get started"
                    glow
                    background={gradient(COLOR.peach2, COLOR.blue5).background}
                    onClick={() => setLocation("/signup")}
                />
            </div>
        </div>
    );
};

const questText = [
    "Go on a wild adventure",
    "Set yourself upon a personal side-quest",
    "Commit to something ruthlessly difficult",
    "Commit to an ordinary challenge",
    "Track your progress and maintain accountability",
    "'Gameify everything' - Tim Apple",
    "Create your own quest line",
];

const Panel1 = () => {
    const [n, setN] = useState(0);

    useEffect(() => {
        const int = setInterval(() => {
            setN((p) => (p > 1000 ? 0 : p + 1));
        }, 5000);

        return () => {
            clearInterval(int);
        };
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                width: "100%",
                paddingBlock: "4%",
                paddingInline: "8%",
                marginBottom: "4%",
            }}
        >
            <div style={{ flex: 1, minWidth: "300px" }}>
                <div style={{ padding: "2em" }}>
                    <h1 style={{ fontSize: "38px", lineHeight: "1" }}>
                        Where quests are embarked upon
                    </h1>
                    <h4 style={{ marginTop: "4%" }}>
                        <span
                            style={{
                                ...textGradient(COLOR.teal3, COLOR.lime3, 45),
                            }}
                        >
                            questie
                        </span>{" "}
                        is the Big Data AI-powered LLM reinforced generative AGI
                        cloud based serverless To-Do list application of the
                        future.
                    </h4>
                </div>
            </div>
            <div className="quoteContainer">
                <h2 key={n} className="slide-in-right">
                    <i>{questText[n % questText.length]}</i>
                </h2>
            </div>
        </div>
    );
};

const Panel2 = () => {
    const Card = ({
        title,
        text,
        background,
        id,
    }: {
        title: string;
        text: string;
        background?: string;
        id: number;
    }) => {
        const defaultPerspectivePx = 200;
        const nAdjustSteps = 10;
        const nRecoverySteps = 14;

        const getCurrentRotation = (
            transformStr: string,
        ): { x: number; y: number } => {
            const rotMatch = Array.from(
                transformStr.matchAll(
                    /rotateX\(([+-]?\d*\.?\d*)deg\) rotateY\(([+-]?\d*\.?\d*)deg\)/g,
                ),
            );

            let rotateX = 0;
            let rotateY = 0;
            if (rotMatch.length) {
                rotateX = Number(rotMatch[0][1]);
                rotateY = Number(rotMatch[0][2]);
            }

            return { x: rotateX, y: rotateY };
        };

        useEffect(() => {
            const card = document.getElementById(`card-container-${id}`);

            if (!card) return;

            card.style.transform = `perspective(${defaultPerspectivePx}px) rotateX(0deg) rotateY(0deg)`;

            let adjustTimeouts: Array<NodeJS.Timeout> = [];
            card.addEventListener("mousemove", (e) => {
                adjustTimeouts.forEach((t) => clearTimeout(t));
                adjustTimeouts = [];

                const x =
                    (e.offsetX - card.clientWidth / 2) / (card.clientWidth / 4);
                const y =
                    (e.offsetY - card.clientHeight / 2) /
                    (card.clientHeight / 4);

                const { x: rotateX, y: rotateY } = getCurrentRotation(
                    card.style.transform,
                );

                const xIncr = (-x - rotateY) / nAdjustSteps;
                const yIncr = (y - rotateX) / nAdjustSteps;

                for (let i = 0; i < nAdjustSteps; i++) {
                    const rotX = rotateY + xIncr * (i + 1);
                    const rotY = rotateX + yIncr * (i + 1);
                    const t = setTimeout(() => {
                        card.style.transform = `perspective(${defaultPerspectivePx}px) rotateX(${rotY.toFixed(
                            3,
                        )}deg) rotateY(${rotX.toFixed(3)}deg)`;
                    }, 100 * i);
                    adjustTimeouts.push(t);
                }
            });

            let resetTimeouts: Array<NodeJS.Timeout> = [];
            card.addEventListener("mouseleave", () => {
                adjustTimeouts.forEach((t) => clearTimeout(t));
                resetTimeouts = [];
                const { x: rotateX, y: rotateY } = getCurrentRotation(
                    card.style.transform,
                );

                const xDecr = rotateX / nRecoverySteps;
                const yDecr = rotateY / nRecoverySteps;
                for (let i = 0; i < nRecoverySteps; i++) {
                    const rotX = rotateX - xDecr * (i + 1);
                    const rotY = rotateY - yDecr * (i + 1);
                    const t = setTimeout(() => {
                        card.style.transform = `perspective(${defaultPerspectivePx}px) rotateX(${rotX.toFixed(
                            3,
                        )}deg) rotateY(${rotY.toFixed(3)}deg)`;
                    }, 50 * i);
                    resetTimeouts.push(t);
                }
            });

            card.addEventListener("mouseenter", () => {
                resetTimeouts.forEach((t) => clearTimeout(t));
            });
        }, [id]);

        return (
            <div
                id={`card-container-${id}`}
                className="cardContainer"
                style={{ background }}
            >
                <h2 style={{ userSelect: "none", pointerEvents: "none" }}>
                    {title} <span className="chevronRight">&rsaquo;</span>
                </h2>
                <div className="cardText">{text}</div>
            </div>
        );
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                flexWrap: "wrap",
            }}
        >
            <Card
                id={1}
                title="Details"
                text="Through questie, we can tackle economic, racial, social, spiritual, and geopolitical challenges to make the world a better place."
                background={gradient(COLOR.red2, COLOR.purp1).background}
            />
            <Card
                id={2}
                title="Notifications"
                text="Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint cillum sint consectetur cupidatat."
                background={gradient(COLOR.pink2, COLOR.blue4).background}
            />
            <Card
                id={3}
                title="Customization"
                text="Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint cillum sint consectetur cupidatat."
                background={gradient(COLOR.teal5, COLOR.lime1).background}
            />
        </div>
    );
};

export default Home;
